import React  from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
import MediaInfoComponent from '../../../../../common/components/common/media-info.component';
import ProgramBasicInfoComponent from './program-basic-info.component';
import { DBaasProgram } from './dbaas-program-details.component';
import { ProgramKeywordMappingComponent } from './program-keyword-mapping.component';
import TenantDetailsComponent from './tenant-details-info.component';


export const ProgramComponent = ({handleInnerFormChange, changeImage,
  deleteSelectedPlan,
  domainFunctions,
  domains,
  endPoints,
  environments,
  handleFormItemChange,
  mediaFiles,
  networks,
  onFormChange,
  onFormItemChange,
  onFormSubmit,
  phases,
  planItems,
  privates,
  publics,
  selectedProgram,
  services,
  handleFormKeywordItemChange,
keywords,
applications,
deleteKeywordItems,
websites,
dbas,
back}: any) => {
  const libraryData = useSelector(selectListItems)
  const tabItems=[
    {
        id:1,
        title:'Program Basic Info',
        component:<ProgramBasicInfoComponent 
        onFormChange={onFormChange}
        selectedProgram={selectedProgram}
        applications={applications}
        />,
    isVisible:true,
    },
    {
      id:2,
      title:'DBaaS Program Details',
      component: <DBaasProgram
      deleteSelectedPlan={deleteSelectedPlan}
      domainFunctions={domainFunctions}
      domains={domains}
      endPoints={endPoints}
      environments={environments}
      networks={networks}
      onFormItemChange={handleFormItemChange}
      phases={phases}
      privates={privates}
      publics={publics}
      planItems={planItems}
      services={services}
      onFormChange={onFormChange}
      selectedProgram={selectedProgram}
      applications={applications}
      handleInnerFormChange={handleInnerFormChange}
      websites={websites}
      dbas={dbas}
  />,
  isVisible:true,
  },

  {
    id:3,
    title:'Keyword Mapping',
    component:<ProgramKeywordMappingComponent
    handleFormKeywordItemChange ={handleFormKeywordItemChange}
    keywords={keywords}
    deleteKeywordItems={deleteKeywordItems}
/>,
isVisible:true,
},
    {
      id:4,
      title:'Media',
      component:<MediaInfoComponent
      changeImage={changeImage}
      fileTypes={libraryData?.result?.FileType}
      onFormItemChange={onFormItemChange}
      mediaFiles={mediaFiles}
      />,
  isVisible:true,
  },
  {
    id:4,
    title:'Tenant Details',
    component:<TenantDetailsComponent
    selectedProgram={selectedProgram}
    />,
isVisible:true,
},
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={onFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default ProgramComponent;
